module.exports = __webpack_public_path__ + "static/media/Logo-11.9b17b8a0.jpg";